export default {
    inserted: function(e, binding) {
        // TODO: find nested input/select/textarea; pop open date picker if present
        e.focus();
    },
};
